import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {setBreadcrumbs, setCreateButton, setSearchHandler, setSearchString, setTitle} from "../actions/main";
import {Link, useNavigate, useParams} from "react-router-dom";
import {UsersService} from "../services/UsersService";
import {ClientService} from "../services/ClientService";
import {Toast} from "primereact/toast";
import {userService} from "../services/UserService";
import Formatter from "../helpers/formater";
import {confirmDialog, ConfirmDialog} from "primereact/confirmdialog";
import NavFilter from "../components/NavFilter";
import TableView from "../components/TableView";
import Total from "../components/Total";
import Contact from "../components/Contact";
import {Tooltip} from "primereact/tooltip";
import Child from "../components/Child";
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {InputTextarea} from "primereact/inputtextarea";
import {Chip} from "primereact/chip";
import {Input} from "react-select/animated";
import {InputText} from "primereact/inputtext";

export default function Clients() {

    const dispatch = useDispatch()
    const locationParams = useParams()
    const [data, setData] = useState(false)
    const [search, setSearch] = useState('');
    const [tab, setTab] = useState(false)
    const [loading, setLoading] = useState(false)
    const toast = useRef()
    const [filter, setFilter] = useState(false);

    const userData = useSelector(function (state) {
        return state.auth.userData
    });

    const [changeDepartmentDialogVisible, setChangeDepartmentDialogVisible] = useState(false);
    const [changeDepartmentId, setChangeDepartmentId] = useState(false);

    const [addCommentDialogVisible, setAddCommentDialogVisible] = useState(false);
    const [commentDialogText, setCommentDialogText] = useState('');

    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const searchString = useSelector((s) => s.searchString) || ''
    const departments = useSelector(function (state) {
        return state.departments
    });
    const [navOptions, setNavOptions] = useState([])
    let navigation = useNavigate();


    let storageColumns = localStorage.getItem('table-client-list-' + (locationParams.type || 'all')),
        defaultColumns = [
            // {name: 'id', label: '№', selected: true},
            {name: 'name', label: 'Клиент', selected: true}
            // {name: 'client', label: 'Источник', selected: true},
        ];


    if (storageColumns) {
        defaultColumns = JSON.parse(storageColumns)
    }
    const [tableRows, setTableRows] = useState(defaultColumns)

    const types = {
        feedback: 'Необработанные',
        kindergarten: 'Детский клуб',
        additional_class: 'Доп. занятия',
        individual_lesson: 'Индивидуальные',
        summer_camp: 'Летний лагерь'
    }

    function updateData(params) {


        ClientService.GetList(params, '').then((response, h) => {

            // if (response.items) {
            setData(response)
            setLoading(false)

            if (navOptions.length === 0) {
                let tabs = []
                
                // Get the tab type, default to 'all' if not specified
                const tabType = locationParams.type || 'all'
                
                // Check if tabs exist and the tab type is available
                if (response['_meta'] && response['_meta'].tabs && response['_meta'].tabs[tabType]) {
                    for (var k of Object.keys(response['_meta'].tabs[tabType])) {
                        tabs.push({
                            label: response['_meta'].tabs[tabType][k],
                            count: null,
                            query: {status_id: k}
                        })
                    }
                } else {
                    // Fallback: create default tabs
                    tabs = [
                        {label: 'Все', count: null, query: {status_id: '0'}},
                        {label: 'Активные', count: null, query: {status_id: '1'}},
                        {label: 'Неактивные', count: null, query: {status_id: '2'}}
                    ]
                }
                setNavOptions(tabs)
            }

        })
    }

    useEffect(() => {
        dispatch(setCreateButton('client/create'))
        dispatch(setSearchHandler(false))
        dispatch(setTitle('Клиенты'))
        dispatch(setBreadcrumbs([
            {link: 'clients', label: 'Клиенты'}
        ]))
    })

    useEffect(() => {
        setTab(false)
        setNavOptions([])
        dispatch(setSearchString(''))
        setLoading(true)
        setFilter({filter: {object_type: locationParams.type || 'all', dep_id: userService.GetCurrentDepartment()}})
        setChangeDepartmentId(currentDepartment)
    }, [currentDepartment, locationParams.type])


    useEffect(() => {
        if (filter) {
            console.log('ch f')
            updateData(filter);
        }
    }, [filter])


    useEffect(() => {
        if (navOptions.length > 0 && navOptions[0].count === null) {
            updateCounters()
        }
    }, [navOptions]);

    function updateCounters() {
        let tabs = []
        navOptions.map((navItem) => {
            tabs.push(getFilterArray(navItem.query))
        })

        ClientService.GetCount({filters: tabs}).then((result) => {
            let copyNavOptions = JSON.parse(JSON.stringify(navOptions));
            // Handle different response formats: array, object with array, or errors
            let counts = [];
            if (Array.isArray(result)) {
                counts = result;
            } else if (result && Array.isArray(result.data)) {
                counts = result.data;
            } else if (result && result.errors) {
                console.error('GetCount error:', result.errors);
                return;
            } else if (typeof result === 'object' && result !== null) {
                // If result is an object with numeric keys, convert to array
                counts = Object.values(result);
            }
            
            counts.forEach((v, k) => {
                if (copyNavOptions[k]) {
                    copyNavOptions[k].count = v;
                }
            });
            setNavOptions(copyNavOptions)
        }).catch((error) => {
            console.error('GetCount failed:', error);
        })
    }

    const tableValue = (propName, el) => {
        switch (propName) {
            case 'name':
                return <Link to={'/client/' + el.id}>{el[propName]}</Link>
                break

            default:

                return (
                    el[propName]
                )
        }
    }


    function handleSearch(e) {
        setLoading(true);
        filter.filter.s = searchString;
        updateData(filter)
        e.preventDefault()
    }

    function setTableRowsHandler(data) {
        setTableRows(data)
    }


    const handlePageClick = (event) => {
        setLoading(true);
        updateData({...filter, page: ++event.selected})
    }

    function getFilterArray(type) {
        const newFilter = JSON.parse(JSON.stringify(filter));
        if (!type || !type.status) {
            delete newFilter.filter.status_id
        }
        newFilter.filter = {...newFilter.filter, ...type}
        // if (type && type !== '0') {
        //     newFilter.filter.user_type = type;
        //     // delete newFilter.filter.status;
        //     newFilter.filter.status = 1;
        // } else {
        //     delete newFilter.filter.user_type
        //     if (type === '0') {
        //         newFilter.filter.status = 2
        //     } else {
        //         delete newFilter.filter.status;
        //     }
        // }
        return newFilter
    }

    function handleChangeStatus(type) {

        setLoading(true);
        let newFilter = getFilterArray(type)
        setFilter(newFilter);
        setTab(type)
    }

    const massRowActions = [
        {
            label: 'Удалить',
            icon: 'pi pi-trash',
            action: 'trash'

        },
        {
            'label': 'Перенести в архив',
            icon: 'pi pi-inbox',
            action: 'archive'
        }
    ];

    const massActionHandler = (action, ids) => {
        if (action.action === 'trash') {
            confirmDialog({
                message: 'Вы хотите удалить этих клиентов?',
                header: 'Подтвердите удаление',
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                accept: () => {
                },
                acceptLabel: 'Удалить выбранных',
                reject: () => {
                    return false
                },
                rejectLabel: 'Нет'
            });
        }
    }

    const rowActions = [
        {
            'label': 'Редактировать',
            icon: 'pi pi-user-edit',
            command: (e) => {
                navigation('/client/' + e.item.rowId)
            }
        },
        {
            'label': 'Удалить',
            icon: 'pi pi-trash',
            command: (e) => {

                confirmDialog({
                    message: 'Вы хотите удалить этого клиента?',
                    header: 'Подтвердите удаление',
                    icon: 'pi pi-info-circle',
                    acceptClassName: 'p-button-danger',
                    accept: () => {
                        ClientService.Delete(e.item.rowId).then((response) => {
                            toast.current.show({severity: 'success', summary: 'Выполнено', life: 3000});
                            updateData(filter)
                            updateCounters()
                        })
                    },
                    acceptLabel: 'Да',
                    reject: () => {
                        return false
                    },
                    rejectLabel: 'Нет'
                });
            }
        }
    ];

    const handlerRawActions = (elId) => {
        const currentRow = data.items.find((el) => {
            return el.id === elId
        })

        if (currentRow) {
            rowActions.map((actionRow, k) => {
                actionRow.rowId = elId


            })

            return rowActions;
        }
    }

    const changeDepartmentDialog = (e) => {


        const changeDepartmentHandler = () => {
            ClientService.Update(changeDepartmentDialogVisible, {
                department_id: changeDepartmentId,
                read: 0
            }).then(() => {
                setChangeDepartmentDialogVisible(false)
                updateData(filter)
                updateCounters()
                toast.current.show({severity: 'success', summary: 'Выполнено', life: 3000});
            })
        }

        const dialogFooter = <>
            <Button label={'Отмена'} onClick={() => setChangeDepartmentDialogVisible(false)}
                    className={'p-button-text'} text/>
            <Button label={'Перенести'} onClick={changeDepartmentHandler}/>
        </>


        return (
            <Dialog footer={dialogFooter} style={{width: '400px'}} header={'Перенести в другой филиал'}
                    visible={changeDepartmentDialogVisible} onHide={() => setChangeDepartmentDialogVisible(false)}>

            </Dialog>
        )
    }
    const addCommentDialog = (e) => {
        const addCommentHandler = () => {
            ClientService.AddComment(addCommentDialogVisible, userData.id, commentDialogText).then(() => {
                setAddCommentDialogVisible(false)
                setCommentDialogText('')
                updateData(filter)
                updateCounters()
                toast.current.show({severity: 'success', summary: 'Выполнено', life: 3000});
            })
        }

        const addCommentDialogFooter = <div className={'p-t-20'}>
            <Button label={'Отмена'} onClick={() => setAddCommentDialogVisible(false)} className={'p-button-text'} text/>
            <Button label={'Добавить'} onClick={addCommentHandler}/>
        </div>


        return (
            <Dialog footer={addCommentDialogFooter} style={{width: '40vw'}} header={'Добавить комментарий'}
                    visible={addCommentDialogVisible} onHide={() => setAddCommentDialogVisible(false)}>
                <div className={'m-t-30'}>
                    {/*<Chip className={'w-100'} image={} label={}/>*/}

                    <div className={'d-flex'}>
                        <img src={'http://yii2.easytickets.pro' + userData.avatar}
                             className={'rounded-circle img-40 m-r-10'}/>
                        <InputTextarea placeholder={'Введите комментарий'} autoResize autoFocus rows={5}
                                       className={'w-100'} value={commentDialogText}
                                       onChange={(e) => setCommentDialogText(e.target.value)}/>
                    </div>
                </div>
            </Dialog>
        )
    }

    return (
        <div className={'product-wrapper'}>
            <Toast ref={toast}></Toast>
            <ConfirmDialog/>
            {changeDepartmentDialog()}
            {addCommentDialog()}


            <div className={'card'}>


                <div className="card-body p-0">


                    <TableView id={'client-list-' + (locationParams.type || 'all')} tableRows={tableRows} data={data}
                               tableValue={tableValue}
                               loading={loading}

                               setTableRows={setTableRowsHandler} handleEdit={(e) => ''} rowActions={rowActions}
                               massRowActions={false} massActionHander={false}
                               rowActionsHandler={handlerRawActions}
                               hideSettings={true}
                               tableClass={'clients-table'}/>

                </div>

            </div>


            <Total data={data} handlePageClick={handlePageClick}/>

        </div>
    )
}